import { Container, Nav, Navbar } from "react-bootstrap";
import { BsInstagram } from "react-icons/bs";
import {BiMailSend} from "react-icons/bi"
import logo from "../../img/logo/SENEPOL TH.webp";
import "./style.css";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <div id="contato">
      <section id="Footer" className="bg-fazenda position-relative pt-5 d-flex align-items-center">
        <Container className="position-relative">
          <div className="row justify-content-center">
            <div className="col-11 col-lg-6 pb-1 pb-lg-3 border-footer">
              <div className="text-center text-white">
                <p className="mb-0 pb-0">Acompanhe a SENEPOL TH nas mídias sociais</p>
                <div>
                  <Navbar className="pb-0">
                    <Nav className="mx-auto">
                      <Nav.Link href="https://www.instagram.com/thsenepol/" className="d-flex">
                        <BsInstagram />
                      </Nav.Link>
                    </Nav>
                  </Navbar>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-lg-6">
              <div className="text-center">
                <div className="py-4">
                  <figure className="m-0">
                    <img src={logo} alt="SENEPOL TH" width={150} />
                  </figure>
                </div>
                <div className="card bg-transparent border-0 p-0">
                  <div className="info text-white card-body">
                    <p>Rod. Mal. Rondon, 830 - Oliveira, Itu/SP</p>
                    <p>CEP 13312-000</p>
                    <p className='mt-2'>Para mais informações, <br /> entre em contato através do nosso instagram:</p>
                    <p>
                      <BsInstagram />{" "}
                      <a
                        href="https://www.instagram.com/thsenepol/"
                        className="text-white text-decoration-none"
                      >
                        {" "}
                        11 9 8597-1039
                      </a>
                    </p>
                    <p className="mt-3">ou através do nosso email:</p>
                    <p> <BiMailSend /> contato@thsenepol.com.br</p>
                    
                  </div>
                  <div className="card-footer p-0 border-0 bg-transparent text-center text-white">
                    <p className="m-0">Todos os direitos reservados.</p>
                    <p>
                      Todos os direitos reservados.{" "}
                      <Link to="/politica-de-privacidade" className="text-white">
                        Política de Privacidade
                      </Link>{" "}
                      |{" "}
                      <Link to="/cookies" className="text-white">
                        Política de Cookies
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
